// extracted by mini-css-extract-plugin
export default {"account":"_1OJYa","selectedAccount":"_2GCZJ","accountDetails":"_1HPn_","first":"_26Wvk","accountName":"_3n-Tg"};